<template>
  <div class="home-view page" :class="pageCollection">
    <div class="home-view__inner page__inner">
      <h1 class="home-view__title">
        Welkom bij AVROTROS
      </h1>
      <AppPageLoader :collection="pageCollection" @loaded="onPageLoaded">
        <AppHomeHero
          v-if="state.data"
          :items="state.data.hero_items"
          class="home-view__home-hero"
        />
        <div
          v-if="state.data"
          :class="`${pageCollection}__inner`"
          class="home-view__content"
        >
          <AppRichText class="home-view__rich-text" :data="state.data.introduction" />
          <template v-for="(block, index) in state.data.content" :key="index">
            <AppDynamicBlock
              :is="useBlock(block)"
              :data="block"
            />
            <AppSterBanner v-if="index === 0" />
          </template>
        </div>
      </AppPageLoader>
    </div>
    <AppAnimatedTitle />
    <LayoutsFooter />
  </div>
</template>

<script setup lang="ts">

import { reactive } from 'vue'
import { THomePage } from '~/types/page-types'
import { useBlock } from '#imports'

const pageCollection = 'home_page'

type TState = {
  data?: THomePage;
};

const state: TState = reactive({
  data: undefined
})

const onPageLoaded = (data) => {
  state.data = data
}
</script>

<style scoped lang="postcss">
.home-view {
  &__inner {
    min-height: 100dvh;
  }

  &__title {
    @mixin sr-only;
  }

  &__home-hero {
    position: sticky;
    top: 0px;
  }

  &__content {
    position: relative;
    z-index: 10;
    background-color: var(--color-blue-prussian);
    padding-bottom: 1px;
    padding-top: 1.75rem;

    @media (--md) {
      padding-top: 4rem;
    }
  }

  &__rich-text {
    @mixin sr-only;
  }
}
</style>
